const DiscountCode = {
  validateDiscount: () => 'DiscountCoupon/Verify',
  applyDiscountCode: () => 'DiscountCoupon/Apply',
};

export default DiscountCode;
